import { render, staticRenderFns } from "./proGeneric.vue?vue&type=template&id=5f434622&"
import script from "./proGeneric.vue?vue&type=script&lang=js&"
export * from "./proGeneric.vue?vue&type=script&lang=js&"
import style0 from "./proGeneric.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports